import React, { Component } from "react";
import service from "../services";
import Loader from "./loader";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DraggerIcon from "../icons/draggericon";

/*
 * ProgramLinks Component
 *
 * Lists all FPG_FILMS and EVENT_* date configuration modules (from admin|getDateConfiguration)
 * in a table. Rows can be reordered with drag and drop (react-beautiful-dnd, same pattern as
 * FooterConfiguration / FilmCategory).
 */
const isProgramModule = (item) =>
  item && typeof item.module === "string" && (item.module === "FPG_FILMS" || item.module === "FPG_SCHEDULE" || item.module.startsWith("EVENT_"));

// A program is "not live" until its appearing (start) date, and after its end date
const isProgramDisabled = (item) => {
  const now = Date.now();
  if (item.startDate && new Date(item.startDate).getTime() > now) return true;
  if (item.endDate && new Date(item.endDate).getTime() < now) return true;
  return false;
};

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class ProgramLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderFlag: true,
      programLinks: [],
    };
    this.apiserve = new service();
  }

  componentDidMount = () => {
    this.sub = this.apiserve.getevent().subscribe((response) => {
      if (response.event === "admin|getDateConfiguration") {
        if (!response.error && Array.isArray(response.data)) {
          this.setState({
            programLinks: response.data
              .filter(isProgramModule)
              .sort((a, b) => (a.sortIndex ?? Infinity) - (b.sortIndex ?? Infinity)),
            loaderFlag: false,
          });
        } else {
          this.setState({ loaderFlag: false });
        }
      } else if (response.event === "admin|programNav|changeOrder") {
        if (response.error) {
          this.apiserve.error((response.data && response.data.error) || "Failed to update order");
          this.getProgramLinks();
        } else {
          this.setState({ loaderFlag: false });
        }
      }
    });
    this.getProgramLinks();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.host !== this.props.host) this.getProgramLinks();
  };

  componentWillUnmount = () => {
    if (this.sub) this.sub.unsubscribe();
  };

  getProgramLinks = () => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("admin|getDateConfiguration", { host: this.props.host });
  };

  onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination || source.index === destination.index) return;
    const programLinks = reorder(this.state.programLinks, source.index, destination.index);
    this.setState({ programLinks, loaderFlag: true });
    this.apiserve.sendevent("admin|programNav|changeOrder", {
      host: this.props.host,
      order: programLinks.map((item, index) => ({ configId: item._id, sortIndex: index })),
    });
  };

  render() {
    const { programLinks, loaderFlag } = this.state;
    return (
      <div className="ticketing_content">
        {loaderFlag && <Loader />}
        <div className="table_wrap product_list_tbl date_congiguration program_links_table">
          {programLinks.length === 0 && !loaderFlag ? (
            <p className="no_data_msg">No program links configured</p>
          ) : (
            <DragDropContext onDragEnd={this.onDragEnd}>
              <table style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: 50 }}></th>
                    <th>Program Menu</th>
                  </tr>
                </thead>
                <Droppable droppableId="program-links" direction="vertical">
                  {(dropProvided) => (
                    <tbody ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
                      {programLinks.map((item, index) => (
                        <Draggable key={item._id || item.module} draggableId={String(item._id || item.module)} index={index}>
                          {(dragProvided, snapshot) => (
                            <tr
                              ref={dragProvided.innerRef}
                              {...dragProvided.draggableProps}
                              className={`${snapshot.isDragging ? "is_dragging" : ""} ${isProgramDisabled(item) ? "disable" : "live"}`.trim()}
                            >
                              <td style={{ width: 50 }}>
                                <span {...dragProvided.dragHandleProps} className="drag_handle" aria-label="Drag to reorder">
                                  <DraggerIcon />
                                </span>
                              </td>
                              <td>{item.module.replace(/_/g, " ")}</td>
                            </tr>
                          )}
                        </Draggable>
                      ))}
                      {dropProvided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </table>
            </DragDropContext>
          )}
        </div>
      </div>
    );
  }
}

export default ProgramLinks;
